import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "site-message-item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close-white" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showNotification)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["site-messages js-site-msgs", {
        'is-show': _ctx.showNotification,
        'is-animate-hide': _ctx.notificationIsClosing,
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.notificationMessage)
              ? (_openBlock(), _createBlock(_component_i18n_t, {
                  key: 0,
                  keypath: _ctx.notificationMessage.keypath,
                  tag: "span"
                }, _createSlots({ _: 2 }, [
                  (_ctx.notificationMessage.link)
                    ? {
                        name: "url",
                        fn: _withCtx(() => [
                          _createElementVNode("a", {
                            href: _ctx.notificationMessage.link.href,
                            target: "_blank",
                            rel: "noopener",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUrlClick && _ctx.handleUrlClick(...args)), ["stop","prevent"]))
                          }, _toDisplayString(_ctx.notificationMessage.link.text), 9, _hoisted_2)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["keypath"]))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
              class: "js-close-site-message site-message-item__close",
              style: {"cursor":"pointer"}
            }, _hoisted_4)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}